import React from 'react';
import { HStack } from '../gluestack/hstack';
import { Text } from '../gluestack/text';

interface TabBadgeProps {
  count: number;
  children: React.ReactNode;
}

export const TabBadge: React.FC<TabBadgeProps> = ({ count, children }) => {
  return (
    <HStack className="relative items-center">
      {children}
      {count > 0 && (
        <HStack className="absolute -right-3 -top-1 web:-top-2 size-[1.4rem] items-center justify-center rounded-full bg-error-500 px-1 z-0">
          <Text size="xs" className="font-black text-white">
            {count > 9 ? '' : count}
          </Text>
        </HStack>
      )}
    </HStack>
  );
};
